import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getAnnouncementById } from '../../services'
import { GetAnnouncementByIdResponse } from '@/modules/announcement/type'
import { AnnouncementQueryKeys } from '@/modules/announcement/keys'

export default function useQueryGetAnnouncementById(
	id: string,
	props?: UseBaseQueryOptions<GetAnnouncementByIdResponse>,
) {
	return useQuery({
		queryKey: [AnnouncementQueryKeys.getAnnouncementById, id],
		queryFn: () => getAnnouncementById(id),
		...props,
	})
}
